(window as Window & typeof globalThis & { __zone_symbol__UNPATCHED_EVENTS: string[] }).__zone_symbol__UNPATCHED_EVENTS = ['message'];
// Angular won't trigger change detections on message event listeners
